var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-base',{style:(("--vh: " + (_vm.W.h/100) + "px")),attrs:{"id":"app"}})}
var staticRenderFns = []

export { render, staticRenderFns }